import React from "react";
import { object, string, array, number, func } from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import { FullScreenImages } from "../story-templates/custom-story-elements/slideshow/FullScreenImages";

import "../story-templates/blank.m.css";

/**
 * This component can be used for adding image gallery on the story page.
 *
 * Example
 * ```javascript
 * import { ImageGalleryElement } from "@quintype/components";
 *
 * <ImageGalleryElement element={element} key={element.id} imageAspectRatio={[4,3]} />
 * ```
 * @category Story Page
 * @component
 */

const ImageGalleryImagesTemplate = ({
  className,
  imageAspectRatio,
  defaultWidth,
  element,
  widths,
  story,
  onClickHandler,
  imgParams,
}) => {
  const numberOfStories = element["story-elements"].length;
  const numberOfRows = Math.ceil(Math.min(numberOfStories, 9) / 3);

  const numberOfElements = element["story-elements"].length;
  const images = element["story-elements"].slice(0, 9).map((image, index) => (
    <figure
      data-test-id="story-element-image-container"
      key={image.id}
      className={`story-element-image-gallery__image-container ${onClickHandler ? "custom-cursor" : ""}`}
      onClick={onClickHandler && (() => onClickHandler(index))}
    >
      <ResponsiveImage
        slug={image["image-s3-key"]}
        metadata={image.metadata}
        aspectRatio={[1, 1]}
        defaultWidth={defaultWidth || 480}
        widths={widths || [250, 480, 640]}
        imgParams={imgParams ? { auto: ["format", "compress"], ...imgParams } : { auto: ["format", "compress"] }}
        className={className || "story-element-image-gallery__image"}
        alt={image.title || story.headline}
      />
      {index === 8 && element?.["story-elements"].length > 9 && (
        <div onClick={onClickHandler && (() => onClickHandler(9))} styleName="more-images-count">
          +{numberOfStories - 9}
        </div>
      )}
    </figure>
  ));

  return (
    <div
      className="story-element-image-gallery"
      data-test-id="story-element-image-gallery"
      style={{ "--number-of-rows": numberOfRows }}
    >
      {images}
      {/* {element["story-elements"].length > 9 && (
        <div onClick={onClickHandler && (() => onClickHandler(8))} styleName="more-images-count">
          +{numberOfStories - 8}
        </div>
      )} */}
    </div>
  );
};

ImageGalleryImagesTemplate.propTypes = {
  className: string,
  imageAspectRatio: array,
  defaultWidth: number,
  element: object,
  widths: array,
  story: object,
  onClickHandler: func,
  imgParams: object,
};

export function ImageGalleryElement({ imageAspectRatio, element, widths, story }) {
  return (
    <FullScreenImages
      template={ImageGalleryImagesTemplate}
      element={element}
      props={{ imageAspectRatio, widths, element, story }}
    />
  );
}

ImageGalleryElement.propTypes = {
  className: string,
  imageAspectRatio: array,
  defaultWidth: number,
  element: object,
  widths: array,
  story: object,
  imgParams: object,
};
